// Settings: one sidebar row, one page of tabs (Users, Shopify, Email, Wise, Payment accounts, Claude access), in the
// anatomy every page has: one header (Settings), the page's tabs under it, then the tab's content with no title of its
// own. Each tab keeps its own address (/settings/users…), so links and ?open= keep working; a tab shows only for the
// roles its nav.ts entry names.
import { type ComponentType, useEffect } from "react";
import { canSee } from "../lib/access.ts";
import { navigate, usePath } from "../lib/router.tsx";
import { me } from "../lib/session.ts";
import { SETTINGS_TABS } from "../nav.ts";
import { EmptyState } from "../ui/controls.tsx";
import { PageHeader, Tabs } from "../ui/PageParts.tsx";

const tabsFor = () => SETTINGS_TABS.filter((t) => canSee(t, me()?.role));

/** /settings itself: the first tab this person can see. */
export function SettingsIndex() {
  const first = tabsFor()[0];
  useEffect(() => {
    if (first) navigate(first.path, { replace: true });
  }, [first]);
  return first ? null : <EmptyState title="No settings for your role" />;
}

/** A settings page under the Settings header and its tabs. A ListPage tab passes `header={false}` (its New goes on its
 * table's bar); a form tab has no title of its own. */
export function withSettingsTabs(Page: ComponentType): ComponentType {
  return function SettingsTab() {
    const path = usePath();
    return (
      <div className="flex h-full flex-col">
        <PageHeader title="Settings" />
        <Tabs tabs={tabsFor().map((t) => ({ key: t.path, label: t.label }))} active={path} onPick={(to) => navigate(to)} />
        <div className="min-h-0 flex-1">
          <Page />
        </div>
      </div>
    );
  };
}
